import ViewGridLayout from "layout/ViewGridLayout";
import { Box } from "@mui/material";
import { useCompetencyMapQuestionsQuery } from "@generated/graphql";
import { useParams } from "react-router-dom";
import CircularLoading from "components/CircularLoading";
import withHeightFitContent from "hocs/withHeightFitContent";
import { useRef } from "react";
import QuestionsList from "./QuestionList";
import ProgressInfo from "./ProgressInfo";

const QuestionsListWithHeightFitContent = withHeightFitContent(QuestionsList);

const QuestionsListTab = () => {
  const ref = useRef<HTMLDivElement>(null);
  const { mapId } = useParams();
  const { data, loading, refetch } = useCompetencyMapQuestionsQuery({
    variables: { competencyMapId: mapId! },
    skip: !mapId,
  });

  const competencyMap = data?.competencyMap;

  if (loading) return <CircularLoading />;

  return (
    <Box sx={{ marginTop: 1 }}>
      <ViewGridLayout
        containerSx={{ flexWrap: "nowrap", flexDirection: { md: "row", xs: "column-reverse" } }}
        LeftColumn={
          <QuestionsListWithHeightFitContent
            competencyMap={competencyMap}
            refetchCompetencyMapQuestions={refetch}
            refProp={ref}
          />
        }
        RightColumn={<ProgressInfo competencyMap={competencyMap} />}
      />
    </Box>
  );
};

export default QuestionsListTab;
